module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section01_01_beach-photo-dd3b86a374c45742f2103a097d902ad1.jpg";